/**
 * Public-only Route
 *
 * 로그인·가입처럼 **로그인된 사용자에게는 보여 줄 일이 없는** 공개 라우트의 래퍼 — ProtectedRoute 의 반대편 선언.
 * 보호 라우트가 미인증 사용자를 /login 으로 보내며 `state.from` 에 원래 자리를 남기듯, 이 래퍼는 인증된 사용자를
 * 그 자리(없으면 AFTER_LOGIN_FALLBACK_PATH)로 돌려보낸다. 로그인 직후(스토어 user 가 채워지는 순간)의 이동도 같은 판정이다.
 *
 * 판정은 라우터의 이 한 곳에 둔다 — 페이지마다 effect 를 두면 빠진 페이지가 생긴다(가입 페이지가 그랬다: 로그인된 채
 * /signup 을 열면 폼이 그대로 보였다).
 */
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/app/stores/authStore';
import { returnPathOf } from '@/features/auth/returnPath';

interface PublicOnlyRouteProps {
  children: React.ReactNode;
}

export const PublicOnlyRoute: React.FC<PublicOnlyRouteProps> = ({ children }) => {
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  if (user) {
    return <Navigate to={returnPathOf(location.state)} replace />;
  }

  return <>{children}</>;
};

export default PublicOnlyRoute;
